import Home from '@ixigo/icons/home';
import Route from '@ixigo/icons/route';
import TrendUp from '@ixigo/icons/trend-up';
import UserMultiple from '@ixigo/icons/user-multiple';
import Wallet from '@ixigo/icons/wallet';
import { CREATORS_PATHS } from '../shared/paths';
import { NAV_TEXT } from './content';

const DASHBOARD = CREATORS_PATHS.dashboard;

/** Each dashboard tab's path, for links between tabs. */
export const DASHBOARD_PATHS = {
	home: DASHBOARD,
	social: `${DASHBOARD}/social`,
	itinerary: `${DASHBOARD}/itinerary`,
	analytics: `${DASHBOARD}/analytics`,
	payout: `${DASHBOARD}/payout`,
} as const;

// The five dashboard tabs (PRD R8), in nav order. Each is a child route of
// the dashboard; the phone bottom bar and the desktop sidebar both render
// from this list.
export const DASHBOARD_TABS = [
	{ to: DASHBOARD_PATHS.home, label: NAV_TEXT.tabs.home, Icon: Home },
	{
		to: DASHBOARD_PATHS.social,
		label: NAV_TEXT.tabs.social,
		Icon: UserMultiple,
	},
	{
		to: DASHBOARD_PATHS.itinerary,
		label: NAV_TEXT.tabs.itinerary,
		Icon: Route,
	},
	{
		to: DASHBOARD_PATHS.analytics,
		label: NAV_TEXT.tabs.analytics,
		Icon: TrendUp,
	},
	{ to: DASHBOARD_PATHS.payout, label: NAV_TEXT.tabs.payout, Icon: Wallet },
] as const;

export type DashboardTabPath = (typeof DASHBOARD_TABS)[number]['to'];

/** The tab a pathname belongs to. Home's path prefixes every other tab, so
 *  the last (most specific) match wins. */
export function activeTabFor(pathname: string): DashboardTabPath {
	const path = pathname.replace(/\/+$/, '');
	const matches = DASHBOARD_TABS.filter(
		(tab) => path === tab.to || path.startsWith(`${tab.to}/`),
	);
	return matches.at(-1)?.to ?? DASHBOARD_TABS[0].to;
}
